import { Box, Container, Grid, Typography, makeStyles, useMediaQuery, useTheme } from '@material-ui/core'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { components } from 'cng-web-lib'
import '../../../assets/scss/psaCustomCss.css';

const {
  button: { CngButton }
} = components

const useStyles = makeStyles((theme) => ({
  divider: {
    height: 4,
    width: 48,
    maxWidth: '100%',
    backgroundColor: '#f3a73e'
  },
 button: {
  borderRadius: 999,
  fontSize: 16,
  fontWeight: 700,
  lineHeight: 1.2,
  textTransform: 'none',
  fontFamily: '"Asap", sans-serif',

  '&.ng-button-filled-primary': {
    backgroundColor: '#f3a73e',
    boxShadow: 'none',
    color: '#FFFFFF', 

    '&:hover': {
      backgroundColor: '#d98f1f', 
      boxShadow: `0px 3px 7px rgba(0, 0, 0, 0.08),
        0px 6px 12px -2px rgba(0, 0, 0, 0.09),
        0px 15px 32px -3px rgba(0, 0, 0, 0.1)`
    },

    '&:focus': {
      backgroundColor: '#d98f1f' 
    },

    '&:active': {
      backgroundColor: '#a66a12' 
    }
  },

  '&.ng-button-filled-secondary': {
    backgroundColor: 'transparent',
    color: '#f3a73e', 
    border: 'none',
    boxShadow: 'inset 0 0 0 2px #f3a73e',

    '&:hover': {
      backgroundColor: '#f3a73e26' 
    },

    '&:focus': {
      backgroundColor: '#f3a73e4d'
    },

    '&:active': {
      backgroundColor: '#f3a73e66'
    }
  }
},
  heading: {
    fontFamily: '"Asap", sans-serif',
    fontWeight: 700
  },
  subHeading: {
    fontFamily: '"Asap", sans-serif',
    fontWeight: 500
  },
  benefitTitle: {
    fontFamily: '"Asap", sans-serif',
    fontWeight: 700
  },
  benefitDescription: {
    fontFamily: '"Asap", sans-serif'
  }
}))

function Hero1() {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const xsDown = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <Container style={{ paddingTop: xsDown ? 30 : 60, paddingBottom: 15 }}>
      <Grid container spacing>
        <Grid item xs={12} md={6}>
          <Box py={xsDown ? 6 : 10} style={{ paddingBottom: 15 }}>
            <Typography variant='h1' className={classes.heading}>
              PSAH Digital Trade Navigator: Seamless North American Compliance and Cargo Visibility 
            </Typography>
            <Box mt={2} mb={1}>
              <Box className={classes.divider} />
            </Box>
            <Box mb={2}>
              <Typography className={classes.subHeading} style={{ fontWeight: 700,marginBottom: 8 }}>
                Simplify the Complexity of Cross-Border Trade
              </Typography>

              <Typography className={classes.benefitDescription} style={{ marginBottom: 8 }}>
                Increased regulatory oversight at the <strong>U.S.-Canada border</strong> demands robust digital tools. 
                PSAH's Digital Trade Navigator provides a <strong>single, secure web-based platform</strong> that streamlines 
                every aspect of cross-border filing and documentation, eliminating the bottleneck of manual 
                paperwork and reducing compliance risks.
              </Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm='auto'></Grid>
              <Grid item xs={12} style={{ marginLeft: 200 }}>
                <CngButton
                  className={classes.button}
                  onClick={() => history.push('/login')}
                >
                  Login
                </CngButton>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Container>
  )
}

export default Hero1
